import axios from "axios"

export default {
    async Table(data){
        const response = await axios.post(`/api/mobiledeviceoperation/table`,data)
        return response
    },
    async ChangeActiveStatus(code){
        const response = await axios.post(`/api/mobiledeviceoperation/changeactivestatus/${code}`)
        return response
    },
    async Delete(code){
        const response = await axios.post(`/api/mobiledeviceoperation/delete/${code}`)
        return response
    },
    async UpdateAlias(code,alias){
        const response = await axios.post(`/api/mobiledeviceoperation/update/alias/${code}/${alias}`)
        return response
    }
}